// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import ArrowIcon from '@/views/components/common/ArrowIcon';
import NoDataCell from './NoDataCell';

// Types
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

// Utils
import { formatMessage, formatPercentage } from '../../../utils/i18n';

type Props = {
  value?: number;
  className?: string;
  onClick?: () => void;
  id?: string;
  disclaimer?: string;
  hasDisclaimer?: boolean;
  item?: ComparisonItem;
  locale?: Locale;
  decimalPlace?: number;
};

const AdjustmentCell: React.FunctionComponent<Props> = ({ value, className, disclaimer, item, onClick, id, hasDisclaimer, locale, decimalPlace }: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} onClick={onClick} id={id} />;
  }

  const formattedAdjustment = value ? formatPercentage(Math.abs(value), decimalPlace, locale) : '-';

  return (
    <div className={classNames('cell adjustment-cell', className)} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      <span className="markup-container">
        {!value && <span className="adjustment neutral">{formattedAdjustment}</span>}

        {value > 0 && (
          <span className="adjustment">
            <ArrowIcon margin="0 4px 0 0" title={formatMessage('Common.Upside')} type="full-up" useHTMLEntity />
            {formattedAdjustment}
          </span>
        )}

        {value < 0 && (
          <span className="adjustment">
            <ArrowIcon margin="0 4px 0 0" title={formatMessage('Common.Downside')} type="full-down" useHTMLEntity />
            {formattedAdjustment}
          </span>
        )}

        {hasDisclaimer && '*'}
      </span>
    </div>
  );
};

export default AdjustmentCell;
